import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_22348_4892)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.6613 5.31271L7.30267 0.650046C6.80602 0.286369 6.21837 0.0673206 5.60485 0.017181C4.99133 -0.0329587 4.3759 0.0877689 3.82679 0.365982C3.27769 0.644194 2.81634 1.06903 2.4939 1.59338C2.17146 2.11774 2.00051 2.72115 2 3.33671V12.6667C1.99905 13.2829 2.1691 13.8872 2.49124 14.4125C2.81337 14.9377 3.27495 15.3633 3.8246 15.6418C4.37425 15.9203 4.99039 16.0408 5.60445 15.9898C6.21851 15.9389 6.8064 15.7186 7.30267 15.3534L13.6613 10.6907C14.0833 10.3811 14.4263 9.97645 14.6628 9.50958C14.8993 9.04271 15.0225 8.52672 15.0225 8.00338C15.0225 7.48004 14.8993 6.96404 14.6628 6.49718C14.4263 6.03031 14.0833 5.62568 13.6613 5.31605V5.31271Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22348_4892",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgPlay;
